module.exports = "/static/media/dtmf-1.d72dbc88.mp3";